import { render, staticRenderFns } from "./FlagshipProfilingStepIntroductionVideo.vue?vue&type=template&id=2172d51d&"
import script from "./FlagshipProfilingStepIntroductionVideo.vue?vue&type=script&lang=ts&"
export * from "./FlagshipProfilingStepIntroductionVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports